import React from "react";

export const Logo = ({ onClick, testid = "logo-button" }) => (
  <button onClick={onClick} data-testid={testid} className="wordmark" aria-label="idevorai — accueil">
    ide<em>vorai</em>
  </button>
);
